// extracted by mini-css-extract-plugin
export default {"links_container":"profile-page_links_container__BUDkO","link":"profile-page_link__0aaIG","active":"profile-page_active__nLtm6"};